import React, { useState } from "react";
import { useAuthState } from "../../context/AuthState";
import { Image, Badge, Center, Box, Text, Flex, Spacer } from "@chakra-ui/react";
import LazyImage from "react-lazy-blur-image";
import { Link } from "gatsby";
import Placeholder from "../../images/placeholder.jpg";
import { Hide } from "../common/Hide";

export function Card({ cardData, contentType, primaryTagScheme, secondaryTagScheme, hoverBorderColor, collection }: CardProps) {
  const authState = useAuthState();
  const [preview, setPreview] = useState("");
  authState.getPresignedUrlWithKey(cardData.previewS3Key).then((url) => setPreview(url));

  return (
    <Box
      maxW="90vw"
      overflow="hidden"
      bg="white"
      textTransform="capitalize"
      _hover={{
        border: `1px solid white`,
      }}
    >
      <Link to={`/s3?key=${cardData.fileS3Key}&contentType=${contentType}&referenceId=${cardData.referenceId}&collection=${collection}`}>
        <LazyImage
          placeholder={Placeholder}
          uri={preview}
          render={(src) => {
            return <Image src={src} />;
          }}
        />
        <Center mt="1" fontFamily="galdeano" fontSize="1.2rem" fontWeight="600" lineHeight="tight" isTruncated>
          {cardData.name}
        </Center>
        <Center>
          <Text fontFamily="linotte">{cardData.summary}</Text>
        </Center>
        <Box p="6">
          <Flex>
            <Hide>
              <Badge
                bg="white"
                borderRadius="full"
                color={secondaryTagScheme}
                fontFamily="galdeano"
                fontSize="1.05rem"
                mr=".5vh"
                textTransform="capitalize"
              >
                {cardData.tags[0]}
              </Badge>
            </Hide>
            <Hide hide={cardData.tags.length < 2}>
              <Badge
                bg="white"
                borderRadius="full"
                fontFamily="galdeano"
                fontSize="1.05rem"
                color={primaryTagScheme}
                mr=".5vh"
                textTransform="capitalize"
              >
                {cardData.tags[1]}
              </Badge>
            </Hide>
            <Hide hide={cardData.tags.length < 3}>
              <Badge
                bg="white"
                borderRadius="full"
                color={primaryTagScheme}
                fontFamily="galdeano"
                fontSize="1.05rem"
                mr=".5vh"
                textTransform="capitalize"
              >
                {cardData.tags[2]}
              </Badge>
            </Hide>
            <Hide hide={cardData.tags.length < 4}>
              <Badge
                bg="white"
                borderRadius="full"
                color={primaryTagScheme}
                fontFamily="galdeano"
                fontSize="1.05rem"
                mr=".5vh"
                textTransform="capitalize"
              >
                {cardData.tags[3]}
              </Badge>
            </Hide>
          </Flex>
        </Box>
      </Link>
    </Box>
  );
}

interface CardProps {
  cardData: CardData;
  contentType: string;
  primaryTagScheme: string;
  secondaryTagScheme: string;
  hoverBorderColor: string;
  collection: string;
}

export interface CardData {
  name: string;
  summary: string;
  tags: string[];
  previewS3Key: string;
  fileS3Key: string;
  referenceId: string;
}
